export const frSectors = {
    // SECTORS

    'sectors.list.pageTitle': 'Secteurs',
    'sectors.list.sectionTitle': 'Secteurs',
    'sectors.list.emptyLabel': 'Aucun secteur pour le moment.',
    'sectors.list.actions.addGroup': 'Ajouter un secteur',
    'sectors.list.actions.importExcel': 'Import Excel',
    'sectors.list.actions.exportExcel': 'Export Excel',
    'sectors.list.item.floatingLabelTitle': 'Nom',
    'sectors.list.item.floatingLabelCode': 'Code',
    'sectors.list.item.floatingLabelPath': 'Chemin',
    'sectors.list.item.floatingLabelParentName': 'Zone Parente',
    'sectors.details.sectionTitle': 'LISTE CENTRES ENFANTS',
    'sectors.details.detailsInfo':
        'Pas de centre enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Centres » où vous pourrez affecter des secteurs parents.',
    'sectors.details.actions.save': 'Enregistrer',
    'sectors.details.actions.removeSector': 'Supprimer le secteur',
    'sectors.details.actions.disabledRemoveInfo':
        'Ce secteur contient des centres et ne peut être supprimée.',

    // SECTORS >> DETAILS

    'sectors.details.pageTitle': 'Détails secteur',
    'sectors.details.actions.previous': 'Secteurs',
    'sectors.details.dialog.title': 'Suppression de secteur',
    'sectors.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce secteur ?',
    'sectors.details.dialog.validateLabel': 'Supprimer',
    'sectors.details.dialog.cancelLabel': 'Annuler',
    'sectors.details.select.sectionTitle': 'Zone parente',
    'sectors.details.select.title': 'Choisir une zone parente *',
    'sectors.details.select.floatingLabel': 'Zone parente',
    'sectors.details.select.listTitle': 'Choix de la zone parente',
    'sectors.details.select.listInputLabel': 'Chercher un secteur',
    'sectors.details.select.listCloseLabel': 'Fermer',
    'sectors.details.item.floatingLabelTitle': 'Nom',
    'sectors.details.item.floatingLabelCode': 'Code',
    'sectors.details.input.name': 'Saisissez ici le nom du Secteur *',
    'sectors.details.input.code': 'Saisissez ici le code du Secteur *',
    'sectors.details.input.floatingLabelName': 'Nom',
    'sectors.details.input.floatingLabelCode': 'Code',

    // SECTORS >> CREATE

    'sectors.create.pageTitle': 'Création secteur',
    'sectors.create.sectionTitle': 'LISTE CENTRES ENFANTS',
    'sectors.create.createInfo':
        'Pas de centre enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Centres » où vous pourrez affecter des secteurs parents.',
    'sectors.create.select.sectionTitle': 'Zone parente',
    'sectors.create.select.title': 'Choisir une zone parente *',
    'sectors.create.select.floatingLabel': 'Zone parente',
    'sectors.create.select.listTitle': 'Choix de la zone parente',
    'sectors.create.select.listInputLabel': 'Chercher un secteur',
    'sectors.create.select.listCloseLabel': 'Fermer',
    'sectors.create.input.name': 'Saisissez ici le nom du Secteur *',
    'sectors.create.input.code': 'Saisissez ici le code du Secteur *',
    'sectors.create.input.floatingLabelName': 'Nom',
    'sectors.create.input.floatingLabelCode': 'Code',

    //TOAST
    'sectors.import.success': 'Bravo! Secteurs importés avec succès',
};
